import { Injectable } from '@angular/core';
import { RestService } from 'cargo-chief-commons';
import { UrlService } from '../url/url.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';

declare const window: any;

@Injectable({
	providedIn: 'root',
})
export class LoginSetupService {
	C4_CLIENT = 'C4_CLIENT';

	constructor(private urlService: UrlService, private restService: RestService) {}

	updateLoginSetup(isProcessingPayment: boolean = false) {
		const url = this.urlService.loginSetupUrl();
		let loginSetupUser: any = {};
		const loginSetup = localStorage.getItem('loginSetup');
		if (loginSetup) {
			loginSetupUser = JSON.parse(loginSetup)['user'];
		}
		this.restService.GET(url).subscribe(
			(loginSetupResult) => {
				localStorage.setItem('loginSetup', JSON.stringify(loginSetupResult));
			},
			(error) => {
				if (isProcessingPayment) {
					if (window?.analytics?.initialized) {
						const payload = {
							user: loginSetupUser,
							eventSource: this.C4_CLIENT,
							stripeErrorMsg: error?.error || '',
							c4Error: error,
						};
						window.analytics.track(SegmentEventsConstants.user_payment_processing_error, payload);
					}
				}
			}
		);
	}
}
